import axios from 'axios';
import * as actionTypes from '../ActionTypes'
import {baseUrl} from '../../Constants/Constants';
import {notification} from "antd";

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START,
    };
};

export const authSuccess = (user, isAuth, image) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        user,
        isAuth,
        image
    };
};

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error,
    };
};

export const deleteStart = () => {
    return {
        type: actionTypes.DElETE_START,
    };
};

export const deleteSuccess = () => {
    return {
        type: actionTypes.DElETE_SUCCESS,
    };
};

export const deleteFail = () => {
    return {
        type: actionTypes.DElETE_FAIL,
    };
};

export const auth = (email, tokenId, image) => {
    const data = {
        'email': email,
        'idToken': tokenId,
        'pushToken': '',
        'serviceType': 1,
    };
    return (dispatch) => {
        dispatch(authStart());

        const url = `${baseUrl}authentication/oauth/google`;
        axios({
            method: 'post',
            url,
            data
        }).then((response) => {
            localStorage.setItem('image', image);
            localStorage.setItem('token', response.data.data.accessToken)
            localStorage.setItem('user', JSON.stringify(response))
            dispatch(authSuccess(response, '',image));

        })
            .catch((error) => {
                notification.error({message: 'Something went wrong.'})
                dispatch(authFail(error));
            });
    };
};

export const deleteAccount = () => {
    const token = localStorage.getItem('token');
    return (dispatch) => {
        dispatch(deleteStart());
        const url = `${baseUrl}authentication/service`;
        axios({
            method: 'delete',
            url,
            headers: {Authorization: token, app_version: 1, client_app_type: 'web'}
        }).then((response) => {
            dispatch(deleteSuccess());
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            window.location.href = '/';
        })
            .catch((error) => {
                notification.error({message: 'Something went wrong.'})
                dispatch(deleteFail());
            });
    };
}
